import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "#2E2D37",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon/Check 1",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Fill 1",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.56635 18.5337C9.31035 18.5337 9.05435 18.4357 8.85935 18.2407L4.89235 14.2737C4.50235 13.8837 4.50235 13.2507 4.89235 12.8597C5.28335 12.4697 5.91635 12.4697 6.30635 12.8597L9.56635 16.1197L18.8924 6.79374C19.2834 6.40274 19.9164 6.40274 20.3064 6.79374C20.6974 7.18374 20.6974 7.81674 20.3064 8.20774L10.2734 18.2407C10.0784 18.4357 9.82235 18.5337 9.56635 18.5337Z"
		})
	})
});
export default SvgIconCheck;
